import * as S from './styles';

export const Loading = () => {
  return (
    <S.Loader>
      <span>Loading...</span>
    </S.Loader>
  );
};
